import { Dispatch, SetStateAction } from 'react';

import { EDurationSwitcher } from '@/src/components/cross-sale/useCrossSale';
import { IDurations } from '@/src/utils/offers';
import { formatPrice } from '@/src/utils/format/amount';
import { ILocaleType } from '@/src/types';
import { formatDuration } from '@/src/utils/format/date';

interface IProps {
  setDurationSwitcher: Dispatch<SetStateAction<EDurationSwitcher>>;
  durationSwitcher: EDurationSwitcher;
  durations: IDurations[];
  locale: ILocaleType;
  durationRegexp: string | null;
}

export const CrossSaleDurationSwitcher = ({
  setDurationSwitcher,
  durationSwitcher,
  durations,
  locale,
  durationRegexp,
}: IProps) => {
  const classNameActive =
    'rounded-5xl justify-center p-4 px-6 text-center active:text-white font-semibold bg-primary active:bg-primary-dark text-white flex flex-col items-center';
  const classNameInactive =
    'cursor-pointer rounded-5xl justify-center p-4 px-6 text-center active:text-white font-semibold bg-transparent active:bg-primary-dark flex-col text-black flex items-center';

  const classNamePrice = 'w-full text-lg bold h-5';
  const classNameDuration = 'w-full text-sm';

  return (
    <>
      <div className={'mx-auto mb-6 flex flex-col gap-8 md:mr-0'}>
        <div className={'grid grid-cols-3 rounded-5xl bg-overlay p-0.5'}>
          {durationSwitcher === EDurationSwitcher.DAYS_7 && (
            <>
              <button className={classNameActive}>
                <div className={classNamePrice}>
                  {formatPrice(durations[0]?.price, locale)}
                </div>
                <div className={classNameDuration}>
                  {durationRegexp?.replace(
                    '$',
                    formatDuration(durations[0]?.duration)
                  )}
                </div>
              </button>
              <button
                className={classNameInactive}
                onClick={() => setDurationSwitcher(EDurationSwitcher.DAYS_15)}
              >
                <div className={classNamePrice}>
                  {formatPrice(durations[1]?.price, locale)}
                </div>
                <div className={classNameDuration}>
                  {durationRegexp?.replace(
                    '$',
                    formatDuration(durations[1]?.duration)
                  )}
                </div>
              </button>
              <button
                className={classNameInactive}
                onClick={() => setDurationSwitcher(EDurationSwitcher.DAYS_30)}
              >
                <div className={classNamePrice}>
                  {formatPrice(durations[2]?.price, locale)}
                </div>
                <div className={classNameDuration}>
                  {durationRegexp?.replace(
                    '$',
                    formatDuration(durations[2]?.duration)
                  )}
                </div>
              </button>
            </>
          )}
          {durationSwitcher === EDurationSwitcher.DAYS_15 && (
            <>
              <button
                className={classNameInactive}
                onClick={() => setDurationSwitcher(EDurationSwitcher.DAYS_7)}
              >
                <div className={classNamePrice}>
                  {formatPrice(durations[0]?.price, locale)}
                </div>
                <div className={classNameDuration}>
                  {durationRegexp?.replace(
                    '$',
                    formatDuration(durations[0]?.duration)
                  )}
                </div>
              </button>
              <button className={classNameActive}>
                <div className={classNamePrice}>
                  {formatPrice(durations[1]?.price, locale)}
                </div>
                <div className={classNameDuration}>
                  {durationRegexp?.replace(
                    '$',
                    formatDuration(durations[1]?.duration)
                  )}
                </div>
              </button>
              <button
                className={classNameInactive}
                onClick={() => setDurationSwitcher(EDurationSwitcher.DAYS_30)}
              >
                <div className={classNamePrice}>
                  {formatPrice(durations[2]?.price, locale)}
                </div>
                <div className={classNameDuration}>
                  {durationRegexp?.replace(
                    '$',
                    formatDuration(durations[2]?.duration)
                  )}
                </div>
              </button>
            </>
          )}
          {durationSwitcher === EDurationSwitcher.DAYS_30 && (
            <>
              <button
                className={classNameInactive}
                onClick={() => setDurationSwitcher(EDurationSwitcher.DAYS_7)}
              >
                <div className={classNamePrice}>
                  {formatPrice(durations[0]?.price, locale)}
                </div>
                <div className={classNameDuration}>
                  {durationRegexp?.replace(
                    '$',
                    formatDuration(durations[0]?.duration)
                  )}
                </div>
              </button>
              <button
                className={classNameInactive}
                onClick={() => setDurationSwitcher(EDurationSwitcher.DAYS_15)}
              >
                <div className={classNamePrice}>
                  {formatPrice(durations[1]?.price, locale)}
                </div>
                <div className={classNameDuration}>
                  {durationRegexp?.replace(
                    '$',
                    formatDuration(durations[1]?.duration)
                  )}
                </div>
              </button>
              <button className={classNameActive}>
                <div className={classNamePrice}>
                  {formatPrice(durations[2]?.price, locale)}
                </div>
                <div className={classNameDuration}>
                  {durationRegexp?.replace(
                    '$',
                    formatDuration(durations[2]?.duration)
                  )}
                </div>
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};
